import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import type { CleanCopyItem } from 'fym-shared/src/music24/watermarkUpsell';
import { TypedMemo } from '../../../common/types';
import { cleanCopiesMessages as messages } from './cleanCopiesMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the upsell; each part uses its own slice of it */
import styles from '../WatermarkUpsell.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * One file of the clean-copies run (design: trial-upsell b5 `.tu-row`): its label, its size or the
 * reason it stays a preview, and its state ("Clean", "Making 40%", "Pro", "Failed").
 */
const CleanCopyRowComponent: React.FC<{ item: CleanCopyItem }> = ({ item }) => {
  const intl = useIntl();
  let state = intl.formatMessage(messages.stateClean);
  let stateClass: string | undefined = styles.rowStateOk;
  let note: string | null =
    item.width !== null && item.height !== null
      ? intl.formatMessage(messages.size, { width: item.width, height: item.height })
      : null;
  if (item.state === 'making') {
    state =
      item.progress === null
        ? intl.formatMessage(messages.stateQueued)
        : intl.formatMessage(messages.stateMaking, { percent: Math.round(item.progress) });
    stateClass = styles.rowStateRun;
  } else if (item.state === 'needsPro') {
    state = intl.formatMessage(messages.statePro);
    stateClass = undefined;
    note = intl.formatMessage(messages.needsProNote);
  } else if (item.state === 'failed') {
    state = intl.formatMessage(messages.stateFailed);
    stateClass = styles.rowStateBad;
    note = intl.formatMessage(messages.failedNote);
  }
  return (
    <div className={styles.row} data-testid={`clean-copy-${item.state}`}>
      <div>
        {item.label}
        {note !== null && <small>{note}</small>}
      </div>
      <span className={clsx(styles.rowState, stateClass)}>{state}</span>
    </div>
  );
};

export const CleanCopyRow = TypedMemo(CleanCopyRowComponent);
